import { REFUND_PROCESSING_DAYS } from '#root/constants/business';
import FAQPanel from '#root/components/FAQPanel';
import type { FAQItem } from '#root/components/FAQPanel';
import { Timeline } from '#root/components/ui';

interface WalletInfoPanelProps {
  processingTime?: string;
  // Sección desde donde se abre el drawer de preguntas (se muestra bajo su título)
  subtitle?: string;
}

const WalletInfoPanel = ({ processingTime, subtitle = 'Mi Billetera' }: WalletInfoPanelProps) => {
  const refundTimeLabel =
    processingTime ??
    `${REFUND_PROCESSING_DAYS.min}-${REFUND_PROCESSING_DAYS.max} días útiles`;

  const faqs: FAQItem[] = [
    {
      id: 'que-es-saldo',
      question: '¿Qué es el saldo en Guvery?',
      answer: (
        <p>
          Tu saldo es dinero disponible en tu cuenta que puedes usar para pagar acuerdos con
          viajeros, envíos nacionales u otros servicios de Guvery. Se genera por recargas, reembolsos
          o ajustes en los acuerdos. <strong>Nunca expira.</strong>
        </p>
      ),
    },
    {
      id: 'como-recargar',
      question: '¿Cómo recargo mi saldo?',
      answer: (
        <Timeline
          variant="numbered"
          items={[
            'Haz clic en "Recargar"',
            'Selecciona tu banco y moneda',
            'Realiza la transferencia y confírmala',
            'Tu saldo se actualiza una vez validado el pago',
          ]}
        />
      ),
    },
    {
      id: 'como-reembolso-tiempo',
      question: '¿Cómo solicito un reembolso? ¿Cuánto demora?',
      answer: (
        <>
          <Timeline
            variant="numbered"
            items={[
              'Ve a "Reembolsos" y haz clic en "Solicitar Reembolso"',
              'Ingresa tu cuenta bancaria y confirma',
              `Los reembolsos se procesan entre ${refundTimeLabel} desde que lo solicitas`,
            ]}
          />
          <p>Puedes ver el estado en la sección de Reembolsos.</p>
        </>
      ),
    },
    {
      id: 'saldo-expira',
      question: '¿Mi saldo expira?',
      answer: (
        <p>
          No. Tu saldo a favor jamás expira y estará disponible para ti por siempre. Puedes usarlo
          para pagar o solicitar un reembolso en cualquier momento.
        </p>
      ),
    },
  ];

  return (
    <FAQPanel
      faqs={faqs}
      subtitle={subtitle}
      teaserText="Información importante sobre tu saldo, recargas y reembolsos."
    />
  );
};

export default WalletInfoPanel;
